import { allToolsButton, local_host_SN_flag, viewer, _param as local_href_param, getWorkflowParam, userPemission } from 'src/main';
import { ManagedUserLayer, TopLevelLayerListSpecification } from '../layer';
import {Borrowed} from '../util/disposable';
import { removeChildren, removeFromParent } from '../util/dom';
import {responseJson} from '../util/http_request';
import {emptyToUndefined} from '../util/json';
import {cancellableFetchSpecialOk} from '../util/special_protocol_request';
import {message} from '../widget/message';
import {SidePanel, SidePanelManager} from './side_panel';
import {
  DEFAULT_SIDE_PANEL_LOCATION,
  SidePanelLocation,
  TrackableSidePanelLocation
} from './side_panel_location';
import './viewer_settings.css';
import './layer_gene_table_tab.less';
import i18n from '../i18n/i18n';
import {serializeColor} from '../util/color';
import {vec3} from 'gl-matrix';
import {Uint64} from '../util/uint64';
import {hashCombine} from '../gpu_hash/hash_function';
import {hsvToRgb} from '../util/colorspace';
import {debounce} from 'lodash';
import {changeBinSize, check_balance} from '../viewer';
import { thousandth_formatter } from '../util/comm_fun_hq';
import {ImageUserLayer} from '../image_user_layer';
// import {Overlay} from '../overlay';
import { registerLassoOpenDialog } from './register_lasso_open_dialog';
import { getData } from '../util/comm_fun_hq';
// import { ConfigIndependDialog } from './congfig-dialog';

export let _checkColor = ['0000ff', '00ffff', 'ff00ff', '00ff00', 'ff0000', 'ff9600', 'ffffff'];  //  蛋白基础色
// 创建一个element
export const makeElement = (
  tag: string,
  classes?: string[],
  attrs?: Record<string, any>,
  html?: string): HTMLElement => {
  const el: HTMLElement = document.createElement(tag) as HTMLElement;
  el.classList.add(...(classes ?? []));
  Object.entries(attrs ?? {})
    .forEach(([key, value]) => el.setAttribute(key, value));
  el.innerHTML = (html ?? '');
  return el;
};
// 默认span Attribute
const defaultSpans = { 'colspan': '1', 'rowspan': '1' }
// 创建一个单元格
const makeCell = (
  // 允许传入 innerText，元素，或者是产生他们的函数
  supplier: string | HTMLElement | (() => HTMLElement | string), exAttr?: Record<string, string>
): HTMLTableCellElement => {
  const td = makeElement("td", [], defaultSpans) as HTMLTableCellElement;
  const cell = makeElement("div", ["cell"], exAttr);
  // 如果是函数，就拿到执行结果（否则本来就是需要的内容对象/字符串）
  const content: any = typeof supplier === "function" ? supplier() : supplier;
  if (typeof content !== 'object') {
    cell.innerHTML = content;
  } else {
    cell.appendChild(content);
  }
  td.appendChild(cell);
  return td;
};
// 创建一个sort
const makeSort = (
  // 允许传入 innerText，元素，或者是产生他们的函数
  supplier: string | HTMLElement | (() => HTMLElement[]), text?: string
): HTMLTableCellElement => {
  const div = makeElement("div", ["cell"], {title: text}, text) as HTMLTableCellElement;
  const td = makeElement("td", [], defaultSpans) as HTMLTableCellElement;
  const span = makeElement("span", ["caret-wrapper"]);
  // 如果是函数，就拿到执行结果（否则本来就是需要的内容对象/字符串）
  const content: any = typeof supplier === "function" ? supplier() : supplier;
  span.appendChild(content[0]);
  span.appendChild(content[1]);
  // div.title = content[2] ? content[2] : '';
  div.appendChild(span);
  td.appendChild(div);
  return td;
};
const DEFAULT_GENE_PANEL_LOCATION: SidePanelLocation = {
  ...DEFAULT_SIDE_PANEL_LOCATION,
  side: 'left',
  row: 0,
};
export class genePanelState {
  location = new TrackableSidePanelLocation(DEFAULT_GENE_PANEL_LOCATION);
  layerManager: { managedLayers: any; }; JSON() {
    return emptyToUndefined(this.location.toJSON());
  }
  get changed() {
    return this.location.changed;
  }
  toJSON() {
    return emptyToUndefined(this.location.toJSON());
  }
  get visible() {
    return this.location.visible;
  }
  reset() {
    if(viewer && viewer.sidePanelManager){
      const panel = viewer.sidePanelManager.registeredPanels;
      for(let k of panel){
        if(k.name === 'genetable'){
          k.panel?.dispose()
        }
      }
      if(document.getElementsByClassName('gene-view')){
        (document.getElementsByClassName('gene-view')[0].getElementsByClassName('selecte-text')[0] as HTMLElement).innerHTML = (allToolsButton.genelistName as string)?.toLocaleLowerCase().includes('metabon') ? i18n.metabon : (allToolsButton.genelistName as string)?.toLocaleLowerCase().includes('protein') ? i18n.protein : i18n.gene;
      }
    }
    this.location.reset();
  }
  restoreState(obj: unknown) {
    this.location.restoreState(obj);
  }
}
// 获取findvalue对应的所有图层x`
export function findAnnotationDnb(obj: any, findValue: string) {
  let result = [];
  for (let i = 0; i < obj?.length; i++) {
    if (obj[i]?.type === findValue) {
      for (var key in obj[i]) {
        if (typeof obj[i][key] !== 'object' && obj[i][key]) {
          if (key === 'source' || key === 'url') {
            result.push({ key: i, value: obj[i][key] });
          }
        } else if (Array.isArray(obj[i][key]) && obj[i][key][0]) {
          result.push({ key: i, value: obj[i][key][0] });
        } else if (typeof obj[i][key] == 'object') {
          if (key === 'source' && obj[i][key].url) {
            result.push({ key: i, value: obj[i][key].url });
          }
        } else {
          findAnnotationDnb(obj[i][key], findValue)
        }
      }
    }
  }
  if (result.length) {
    return result
  } else {
    return [{ key: 0, value: obj }]
  }
}

export async function getMaxRange(url: any) {
  // let newUrl = url;
  // let _newUrl: string;
  // if(Array.isArray(url)){
  //   newUrl.splice(0, 2);
  //   _newUrl = newUrl.join('/');
  // }else{
  //   _newUrl = url.replace('precomputed://','');
  // }
  // _newUrl = _newUrl.includes('annotation') ? _newUrl.replace('annotation/', '') : _newUrl;
  url = url.replace('annotation/','');
  let req = async (): Promise<any> => {
    return await cancellableFetchSpecialOk(undefined, `${url}/maxValue`, {}, responseJson);
  };
  return await req();
}

export function dec2hex(dec: any, len: number) {//10进制转16进制补0
  var hex = "";
  while (dec) {
    var last = dec & 15;
    hex = String.fromCharCode(((last > 9) ? 55 : 48) + last) + hex;
    dec >>= 4;
  }
  if (len) {
    while (hex.length < len) hex = '0' + hex;
  }
  return hex;
}

function getInitColor(out: Float32Array, x: Uint64){
  let h = hashCombine(0, x.low);
  h = hashCombine(h, x.high);
  const c0 = (h & 0xFF) / 255;
  const c1 = ((h >> 8) & 0xFF) / 255;
  hsvToRgb(out, c0, 0.5 + 0.5 * c1, 1.0);
  return out;
}

export class newGeneTabView extends SidePanel {
  element = document.createElement('div');
  tbody = makeElement('tbody',['all-gene-tbody']);
  button = makeElement('div',['el-button', 'el-button--default', 'is-plain'],{'style': 'display: none'},`<span>${i18n.geneReset}</span>`);
  pagenum: any = 1;
  sortname: any;
  isasc: boolean = false;
  genelist_res:any = {};
  filterparam: string = '';
  TableHead = makeElement('tr', ['geneTable-head']);
  geneElement = makeElement('div',['gene-table','all-gene-table']);
  listEle = makeElement('table',['el-table', 'all-el-table']);
  pagenation = makeElement('div',['el-pagination']);
  loading = makeElement('div',['loader']);
  inputEle = makeElement('input',['filter']) as HTMLInputElement;
  countEl = makeElement('div',['gene-count']);
  // selected组
  selectedGeneDom = makeElement('div',['selected-gene']);
  selectedTableDom = makeElement('div',['selected-gene-table','gene-table']);
  selectedBody = document.createElement('tbody');
  selectedCount: number = 0;
  selectedGeneStr: string = '';   //  勾选基因的名称
  // genelistProperty: any = [];
  selectedTableHead = makeElement('tr', ['geneTable-head'])
  // allDom
  allDom = makeElement('div',['gene-selected-bottom'],{style:"margin-bottom: 0"});
  // 存储selected组（字段值，用于回显）{genename: [Mid, E10]}
  // 存储当前页码已经存在的勾选项
  // 展开svg
  showSvg = `<svg t="1671437412228" style="padding-right: 4px;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3765" width="15" height="15"><path d="M668.734694 532.897959H355.265306c-11.493878 0-20.897959-9.404082-20.897959-20.897959s9.404082-20.897959 20.897959-20.897959h313.469388c11.493878 0 20.897959 9.404082 20.897959 20.897959s-9.404082 20.897959-20.897959 20.897959z" fill="#ffffff" p-id="3766"></path><path d="M512 929.959184c-230.4 0-417.959184-187.559184-417.959184-417.959184s187.559184-417.959184 417.959184-417.959184 417.959184 187.559184 417.959184 417.959184-187.559184 417.959184-417.959184 417.959184z m0-794.122449c-207.412245 0-376.163265 168.75102-376.163265 376.163265s168.75102 376.163265 376.163265 376.163265 376.163265-168.75102 376.163265-376.163265-168.75102-376.163265-376.163265-376.163265z" fill="#ffffff" p-id="3767"></path></svg>`;
  // 关闭sgv
  closeSvg = `<svg t="1671086286757" style="padding-right: 4px;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2692" width="15" height="15"><path d="M512 958.016611c-119.648434 0-232.1288-46.367961-316.736783-130.559656-84.640667-84.255342-131.263217-196.255772-131.263217-315.455235 0-119.168499 46.624271-231.199892 131.232254-315.424271 84.607983-84.191695 197.088348-130.559656 316.736783-130.559656s232.1288 46.367961 316.704099 130.559656c84.67163 84.224378 131.263217 196.255772 131.263217 315.391587 0.032684 119.199462-46.591587 231.232576-131.263217 315.455235C744.1288 911.615966 631.648434 958.016611 512 958.016611zM512 129.983389c-102.623626 0-199.071738 39.743475-271.583282 111.936783-72.480581 72.12794-112.416718 168.063432-112.416718 270.079828s39.903454 197.951888 112.384034 270.047144c72.511544 72.191587 168.959656 111.936783 271.583282 111.936783 102.592662 0 199.071738-39.743475 271.583282-111.936783 72.480581-72.160624 112.416718-168.063432 112.384034-270.079828 0-102.016396-39.903454-197.919204-112.384034-270.016181C711.071738 169.759548 614.592662 129.983389 512 129.983389z" fill="#ffffff" p-id="2693"></path><path d="M736.00086 480.00086 544.00086 480.00086 544.00086 288.00086c0-17.664722-14.336138-32.00086-32.00086-32.00086s-32.00086 14.336138-32.00086 32.00086l0 192L288.00086 480.00086c-17.664722 0-32.00086 14.336138-32.00086 32.00086s14.336138 32.00086 32.00086 32.00086l192 0 0 192c0 17.695686 14.336138 32.00086 32.00086 32.00086s32.00086-14.303454 32.00086-32.00086L544.00258 544.00086l192 0c17.695686 0 32.00086-14.336138 32.00086-32.00086S753.696546 480.00086 736.00086 480.00086z" fill="#ffffff" p-id="2694"></path></svg>`;
  layer_showSvg = `<?xml version="1.0" encoding="UTF-8"?>
    <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="830-需求" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="弹窗" transform="translate(-424.000000, -238.000000)">
                <g id="_2-查看" transform="translate(424.000000, 238.000000)">
                    <rect id="矩形" fill-opacity="0" fill="#D8D8D8" x="0" y="0" width="18" height="18"></rect>
                    <path d="M9,13 C12.3137085,13 15,10 15,9 C15,8 12.3137085,5 9,5 C5.6862915,5 3,8 3,9 C3,10 5.6862915,13 9,13 Z" id="椭圆形" stroke="#FFFFFF" stroke-width="2"></path>
                    <circle id="椭圆形" stroke="#FFFFFF" cx="9" cy="9" r="1.5"></circle>
                </g>
            </g>
        </g>
    </svg>`
  layer_hideSvg = `<svg t="1693299910071" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4025" width="24" height="24"><path d="M253.6 679.2l109.6-109.6C356 552 352 532.8 352 512c0-88 72-160 160-160 20.8 0 40 4 57.6 11.2l82.4-82.4C607.2 264.8 560 256 512 256c-168 0-329.6 106.4-384 256 24 65.6 68.8 123.2 125.6 167.2z" p-id="4026" fill="#ffffff"></path><path d="M416 512v4.8L516.8 416H512c-52.8 0-96 43.2-96 96zM770.4 344.8l163.2-163.2L888 136l-753.6 753.6 45.6 45.6 192.8-192.8A390.4 390.4 0 0 0 512 768c167.2 0 330.4-106.4 384.8-256-24-65.6-69.6-123.2-126.4-167.2zM512 672c-20 0-40-4-57.6-11.2l53.6-53.6h4.8c52.8 0 96-43.2 96-96v-4.8l53.6-53.6C668 472 672 492 672 512c0 88-72 160-160 160z" p-id="4027" fill="#ffffff"></path></svg>`
  imageMaxValue: any = {};
  onlyHeatmap: boolean = false;
  // genelist: any = [];    //  存储list列表
  gene_index: number = 0;   //  存储上下键切换时的数据index，用于定义滚动条的位置
  get layerManager() {
    return this.manager.layerManager;
  }
  constructor(sidePanelManager: SidePanelManager, state: genePanelState,
    public manager: Borrowed<TopLevelLayerListSpecification>, parentEle: HTMLElement) {
    super(sidePanelManager, state.location);
    let { element, geneElement, allDom, inputEle, countEl, selectedGeneDom, listEle, pagenation } = this;
    countEl.style.display = 'flex';
    element.className = 'neuroglancer-annotation-geneTable-tab selecte-views-options';
    this.sortname = viewer.binSize.value === 'cellbin' ? 'expCount'  : 'MIDcount';// 默认midCount降序排序
    parentEle.appendChild(element);
    element.appendChild(inputEle);     //  筛选过滤
    element.appendChild(countEl);      //  mid 统计
    element.appendChild(selectedGeneDom);     //
    element.appendChild(allDom);       //  selected组基因list
    element.appendChild(geneElement);
    geneElement.appendChild(listEle);
    element.appendChild(pagenation)           //  页码
    this.gene_filter();
    this.initGeneTable();
    allDom.dataset.checked = 'false';
    element.addEventListener('click', (event) => {
      event.stopPropagation()
    });
    this.addkeyDown();
    geneElement.addEventListener('keyup',(e:Event)=>{
      e.preventDefault();
    });
  }
  async initGeneTable(is_need_get_genelist: boolean = true){
    if(document.getElementsByClassName('gene-view')){
      (document.getElementsByClassName('gene-view')[0].getElementsByClassName('selecte-text')[0] as HTMLElement).innerHTML = (allToolsButton.genelistName as string)?.toLocaleLowerCase().includes('metabon') ? i18n.metabon : (allToolsButton.genelistName as string)?.toLocaleLowerCase().includes('protein') ? i18n.protein : i18n.gene;
    }
    if(is_need_get_genelist)await this.getGenelist();
    if(allToolsButton.genelistFile !== 'null' && this.genelist_res.code === 200){
      this.geneCount();
      if(this.genelist_res.data.length > 0){
        this.getSelectedGene();
        this.getCompleteGene();
        this.genePagenation();
        if(Object.keys(viewer.saveSelectedKeyVal).length === 1 ){
          const allScroll = document.getElementsByClassName('el-table')[1].scrollHeight / this.genelist_res.data.length;
          document.getElementsByClassName('all-gene-table')[0].scrollTop = this.gene_index * allScroll;
        }
      }else{
        this.listEle.innerHTML = `<div class="nodata">${i18n.nodata}</div>`;
        this.loading.style.display = 'none';
      }
    }else{
      this.listEle.innerHTML = `<div class="nodata">${i18n.nodata}</div>`;
      this.loading.style.display = 'none';
    }
  }
  allDomFold(){
    this.allDom.innerHTML = `${this.closeSvg} <span>${i18n.genePanelAll}</span>`;
    this.geneElement.classList.remove('expand');
    this.geneElement.classList.add('fold');
    this.pagenation.classList.add('fold');
    this.pagenation.classList.remove('expand');
    this.allDom.dataset.checked = 'false';
  }
  allDomExpand(){
    this.allDom.innerHTML = `${this.showSvg} <span>${i18n.genePanelAll}</span>`;
    this.geneElement.classList.remove('fold');
    this.geneElement.classList.add('expand');
    this.pagenation.classList.add('expand');
    this.pagenation.classList.remove('fold');
    this.allDom.dataset.checked = 'true';
  }
  gene_filter(){
    this.inputEle.placeholder = (allToolsButton.genelistName as string).toLocaleLowerCase().includes('metabon') ? i18n.genePanelMetabonSearch : (allToolsButton.genelistName as string).toLocaleLowerCase().includes('protein') ? i18n.genePanelProteinSearch : i18n.genePanelGeneSearch;
    this.inputEle.addEventListener('change', (event: Event) => {
      this.filterparam = (event.target as any).value;
      this.pagenum = 1;
      this.initGeneTable();
    });
  }
  geneCount() {
    removeChildren(this.countEl);
    const countLabel = document.createElement('span');
    countLabel.innerHTML = (allToolsButton.genelistName as string).includes('metabon') ? i18n.total_intensity : i18n.total_mid_count;
    const countValue = document.createElement('span');
    countValue.innerHTML = thousandth_formatter(this.genelist_res.mid_total ?? 0).toString();
    this.countEl.appendChild(countLabel)
    this.countEl.appendChild(countValue)
  }
  getSelectedGene(){
    this.getSelectedTop();
    this.getSelectedHead();
    this.getSelectedBody();
  }
  getSelectedTop(){
    removeChildren(this.selectedGeneDom);
    removeChildren(this.selectedTableDom);
    this.selectedGeneDom.innerHTML = '';
    const select = Object.keys(viewer.saveSelectedKeyVal).length;
    this.selectedGeneDom.dataset.checked = this.selectedTableDom.classList.contains('selected-fold') ? 'false' : 'true';   //  true展开，false折叠
    const top = makeElement('div',['gene-selected-top']);
    const left = makeElement('div',[],{style: 'display: flex'});
    const icon = makeElement('div',[],{},`${this.selectedTableDom.classList.contains('selected-fold') ? this.closeSvg : this.showSvg}`);
    const text = makeElement('span',['selected-gene-num'],{style: 'line-height: 1.5rem;'},`${select} ${i18n.genePanelSelectedGene}`);
    top.appendChild(left);
    left.appendChild(icon);
    left.appendChild(text);
    if (userPemission.toolbar && userPemission.midFilter && !local_href_param.isReadOnly) {
      const right = makeElement('button', ['mid_filter_run_submit', 'async_submit_btn_loading', 'gene-save-filter'], {type: 'button', style: 'display: flex'},
      `<i class="submit_btn_el-icon-loading"><svg t="1687856555440" class="mid_filter_run_svg icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1917" width="14" height="14"><path d="M511.882596 287.998081h-0.361244a31.998984 31.998984 0 0 1-31.659415-31.977309v-0.361244c0-0.104761 0.115598-11.722364 0.115598-63.658399V96.000564a31.998984 31.998984 0 1 1 64.001581 0V192.001129c0 52.586273-0.111986 63.88237-0.119211 64.337537a32.002596 32.002596 0 0 1-31.977309 31.659415zM511.998194 959.99842a31.998984 31.998984 0 0 1-31.998984-31.998984v-96.379871c0-51.610915-0.111986-63.174332-0.115598-63.286318s0-0.242033 0-0.361243a31.998984 31.998984 0 0 1 63.997968-0.314283c0 0.455167 0.11921 11.711527 0.11921 64.034093v96.307622a31.998984 31.998984 0 0 1-32.002596 31.998984zM330.899406 363.021212a31.897836 31.897836 0 0 1-22.866739-9.612699c-0.075861-0.075861-8.207461-8.370021-44.931515-45.094076L195.198137 240.429485a31.998984 31.998984 0 0 1 45.256635-45.253022L308.336112 263.057803c37.182834 37.182834 45.090463 45.253022 45.41197 45.578141A31.998984 31.998984 0 0 1 330.899406 363.021212zM806.137421 838.11473a31.901448 31.901448 0 0 1-22.628318-9.374279L715.624151 760.859111c-36.724054-36.724054-45.018214-44.859267-45.097687-44.93874a31.998984 31.998984 0 0 1 44.77618-45.729864c0.32512 0.317895 8.395308 8.229136 45.578142 45.411969l67.88134 67.88134a31.998984 31.998984 0 0 1-22.624705 54.630914zM224.000113 838.11473a31.901448 31.901448 0 0 0 22.628317-9.374279l67.88134-67.88134c36.724054-36.724054 45.021826-44.859267 45.097688-44.93874a31.998984 31.998984 0 0 0-44.776181-45.729864c-0.32512 0.317895-8.395308 8.229136-45.578142 45.411969l-67.88134 67.884953a31.998984 31.998984 0 0 0 22.628318 54.627301zM255.948523 544.058589h-0.361244c-0.104761 0-11.722364-0.115598-63.658399-0.115598H95.942765a31.998984 31.998984 0 1 1 0-64.00158h95.996952c52.586273 0 63.88237 0.111986 64.337538 0.11921a31.998984 31.998984 0 0 1 31.659414 31.97731v0.361244a32.002596 32.002596 0 0 1-31.988146 31.659414zM767.939492 544.058589a32.002596 32.002596 0 0 1-31.995372-31.666639v-0.361244a31.998984 31.998984 0 0 1 31.659415-31.970085c0.455167 0 11.754876-0.11921 64.34115-0.11921h96.000564a31.998984 31.998984 0 0 1 0 64.00158H831.944685c-51.936034 0-63.553638 0.111986-63.665624 0.115598h-0.335957zM692.999446 363.0176a31.998984 31.998984 0 0 1-22.863126-54.381656c0.317895-0.32512 8.229136-8.395308 45.41197-45.578141l67.88134-67.884953A31.998984 31.998984 0 1 1 828.693489 240.429485l-67.892177 67.88134c-31.020013 31.023625-41.644196 41.759794-44.241539 44.393262l-0.697201 0.722488a31.908673 31.908673 0 0 1-22.863126 9.591025z" fill="#ffffff" p-id="1918"></path></svg></i>
      ${i18n.genePanelStateSave}`);
      right.title = i18n.genePanelStateSaveTips;
      top.appendChild(right);
      this.registerEventListener(right, 'click', debounce(() => this.save_filter_info_and_gef(), 700));
    }
    if(select < 1){
      this.selectedGeneDom.style.display = 'none';
      this.allDom.style.display = 'none';
    }
    this.selectedGeneDom.appendChild(top);
    const table = makeElement('table',['el-table', 'genetable-selected-table']);
    viewer.proteinMergeColor.value ? table.classList.remove('mutil-color-property-show') : table.classList.add('mutil-color-property-show');
    if(document.getElementsByClassName('gene-save-filter')[0])(document.getElementsByClassName('gene-save-filter')[0] as HTMLElement).style.display = viewer.proteinMergeColor.value ? 'flex' : 'none';
    table.appendChild(this.selectedBody);
    this.selectedTableDom.appendChild(table);
    this.selectedGeneDom.appendChild(this.selectedTableDom);
    icon.addEventListener('click',()=>{
      if(this.selectedGeneDom.getAttribute('data-checked') === 'true'){
        icon.innerHTML = `${this.closeSvg}`;
        this.selectedTableDom.classList.remove('selected-expand');
        this.selectedTableDom.classList.add('selected-fold');
        this.selectedGeneDom.dataset.checked = 'false';
      }else{
        icon.innerHTML = `${this.showSvg}`;
        this.selectedTableDom.classList.remove('selected-fold');
        this.selectedTableDom.classList.add('selected-expand');
        this.selectedGeneDom.dataset.checked = 'true';
      }
    });
  }
  getSelectedHead(){
    this.selectedBody.innerHTML = '';
    this.selectedTableHead.innerHTML = '';
    const cb = makeElement('input',['ng-common-checkbox'],{type: 'checkbox'}) as HTMLInputElement;
    const tdCb = makeElement("td", [], defaultSpans) as HTMLTableCellElement;
    const cellCb = makeElement("div", ["cell"],{});
    cellCb.appendChild(cb);
    tdCb.appendChild(cellCb);
    this.selectedTableHead.appendChild(tdCb);
    cb.checked = true;
    cb.addEventListener('change',(e:Event)=>{
      if(!(e.target as HTMLInputElement).checked){
        this.selectedGeneStr = '';
        (document.getElementsByClassName('gene-selected-bottom')[0] as HTMLElement).style.display = 'none';
        this.initReset();
      }
    });
    if(this.genelist_res.code === 200){
      const genelistProperty = Object.keys(this.genelist_res.data[0]);
      for (let i = 0; i < 2; i++) {
        const td = makeElement("td", [], defaultSpans) as HTMLTableCellElement;
        let cell: any;
        if ((allToolsButton.genelistName as string)?.toLocaleLowerCase().includes('metabon') && genelistProperty[i] === 'gene') {
          cell = makeElement("div", ["cell"],{},`${i18n.metabon}`);
        } else if ((allToolsButton.genelistName as string)?.toLocaleLowerCase().includes('metabon') && genelistProperty[i] === 'MIDcount') {
          cell = makeElement("div", ["cell"],{},`${i18n.intensity}`);
        } else {
          cell = makeElement("div", ["cell"],{},`${i18n[genelistProperty[i]]}`);
        }
        td.appendChild(cell)
        this.selectedTableHead.appendChild(td)
      }
      console.log(Object.values(viewer.saveSelectedKeyVal).every((item)=> item[2] === 0))
      const { layer_showSvg, layer_hideSvg } = this
      const layer_visible = makeElement('div',['selected-gene-all-layer-visible'],{'data-checked': 'true'});
      layer_visible.innerHTML = layer_visible.dataset.checked === 'true' ? layer_showSvg : layer_hideSvg;
      const colortTd = makeElement("td", [], defaultSpans) as HTMLTableCellElement;
      const cellColor = makeElement("div", ["cell"],{style: 'display: flex; justify-content: space-between;align-items: center;'});
      const colorItmen = makeElement('div',[],{},`${i18n.color}`)
      colortTd.appendChild(cellColor)
      cellColor.appendChild(colorItmen);
      cellColor.appendChild(layer_visible);
      this.selectedTableHead.appendChild(colortTd);
      this.selectedBody.appendChild(this.selectedTableHead);
      this.registerEventListener(layer_visible, 'click',  ()=>{this.hide_or_show_all_layers(layer_visible)});
    }
  }
  getSelectedBody(){
    if(Object.keys(viewer.saveSelectedKeyVal).length > 0){
      for(let i in viewer.saveSelectedKeyVal){
        this.addNewSelectedItem(i, viewer.saveSelectedKeyVal[i][0], viewer.saveSelectedKeyVal[i][1], viewer.saveSelectedKeyVal[i][2]);
      }
    }else{
      this.allDomExpand();
    }
  }
  getAllDom(){
    this.allDom.innerHTML = '';
    this.allDom.dataset.checked = this.geneElement.classList.contains('fold') ? 'false' : 'true';  // true 默认展开，close默认折叠
    const icon = makeElement('span',[],{style: 'display: flex'});
    icon.innerHTML = `${this.geneElement.classList.contains('fold') ? this.closeSvg : this.showSvg} <span>${i18n.genePanelAll}</span>`;
    this.allDom.appendChild(icon);
    // this.allDom.innerHTML = `${this.geneElement.classList.contains('fold') ? this.closeSvg : this.showSvg} <span>${i18n.genePanelAll}</span>`;
    this.registerEventListener(icon, 'click',()=>{
      if(this.allDom.getAttribute('data-checked') === 'true'){
        icon.innerHTML = `${this.closeSvg} <span>${i18n.genePanelAll}</span>`;
        this.geneElement.classList.remove('expand');
        this.geneElement.classList.add('fold');
        this.pagenation.classList.add('fold');
        this.pagenation.classList.remove('expand');
        this.allDom.dataset.checked = 'false';
      }else{
        icon.innerHTML = `${this.showSvg} <span>${i18n.genePanelAll}</span>`;
        this.geneElement.classList.remove('fold');
        this.geneElement.classList.add('expand');
        this.pagenation.classList.add('expand');
        this.pagenation.classList.remove('fold');
        this.allDom.dataset.checked = 'true';
      }
    });
  }
  getCompleteGene(){
    this.getAllDom();
    this.getCompleteGeneHead();
    this.getCompleteGeneBody();
  }
  getCompleteGeneHead(){
    const { TableHead, tbody } = this;
    removeChildren(tbody);
    removeChildren(TableHead);
    const cb = makeElement("input") as HTMLInputElement;
    cb.type = "checkbox";
    cb.style.visibility = 'hidden';
    TableHead.appendChild(cb);
    let genelistProperty = Object.keys(this.genelist_res.data[0]);
    // 代谢数据不展示E10
    if ((allToolsButton.genelistName as string).toLocaleLowerCase().includes('metabon')) {
      genelistProperty = genelistProperty.filter((item) => item !== 'E10');
    }
    for (let i = 0; i < (genelistProperty.length -1) * 2; i++) {
      if(i < genelistProperty.length - 1){
        let label: string;
        if ((allToolsButton.genelistName as string).toLocaleLowerCase().includes('metabon') && genelistProperty[i] === 'gene') {
          label = i18n.metabon;
        } else if ((allToolsButton.genelistName as string).toLocaleLowerCase().includes('metabon') && genelistProperty[i] === 'MIDcount') {
          label = i18n.intensity;
        } else {
          label = `${i18n[genelistProperty[i]]}`;
        }
        const sort = makeSort(() => {
          const _dataFlag = this.sortname === genelistProperty[i] ? 'true' : 'false';
          if (this.sortname && this.sortname === genelistProperty[i]) {
            if (this.isasc.toString() === 'true') {
              const ascI = makeElement('i', ['sort-caret', 'ascending', genelistProperty[i]], { 'dataFlag': _dataFlag, 'style': 'border-bottom-color: yellow' });
              const descI = makeElement('i', ['sort-caret', 'descending', genelistProperty[i]], { 'dataFlag': !_dataFlag });
              return [ascI, descI]
            } else {
              const ascI = makeElement('i', ['sort-caret', 'ascending', genelistProperty[i]], { 'dataFlag': !_dataFlag });
              const descI = makeElement('i', ['sort-caret', 'descending', genelistProperty[i]], { 'dataFlag': _dataFlag, 'style': 'border-top-color: yellow' });
              return [ascI, descI]
            }
          } else {
            const ascI = makeElement('i', ['sort-caret', 'ascending', genelistProperty[i]], { 'dataFlag': _dataFlag });
            const descI = makeElement('i', ['sort-caret', 'descending', genelistProperty[i]], { 'dataFlag': _dataFlag });
            return [ascI, descI]
          }
        }, label);
        TableHead.appendChild(sort);
      }
      TableHead.getElementsByTagName('i')[i].addEventListener('click', (event: Event) => {
        const dataFlag = (event.target as Element).getAttribute('dataFlag');
        console.log(dataFlag, (event.target as Element).classList[2])
        this.sortname = dataFlag === 'true' ? '' : (event.target as Element).classList[2];
        this.isasc = (event.target as Element).classList[1] == 'ascending';
        this.initGeneTable();
      })
    }
    this.tbody.appendChild(TableHead);
  }
  getCompleteGeneBody(){
    this.genelist_res.data.forEach((item: any, index: number) => {
      const genelistProperty = Object.keys(this.genelist_res.data[0]);
      const gene_protein = item[ genelistProperty[0] ]?.trim();
      const tr = makeElement('tr',['splice-pic-tr', `splice-pic-tr_${gene_protein}`]);
      const cb = makeElement('input',['ng-common-checkbox', `${gene_protein}_cb`],{type: 'checkbox'}) as HTMLInputElement;
      const td = makeElement("td", [], defaultSpans) as HTMLTableCellElement;
      const cell = makeElement("div", ["cell"]);
      cell.appendChild(cb);
      if (viewer.binSize.value === 'cellbin') {//cellbin的复选框目前不可点击
        // cb.disabled = true;
        cb.style.visibility = 'hidden';
      }
      td.appendChild(cell);
      tr.appendChild(td)
      const select_genes = Object.keys( viewer.saveSelectedKeyVal );
      cb.checked = false;
      if(select_genes.includes(gene_protein)){
        cb.checked = true;
        cb.classList.add(gene_protein);
        tr.classList.add('splice-pic-tr_cb_checked')
        if(Object.keys(viewer.saveSelectedKeyVal).length === 1)this.gene_index = index;
      }
      for (let k in genelistProperty) {
        // 代谢数据不展示E10
        if(genelistProperty[k] === 'id' || (genelistProperty[k] === 'E10' && (allToolsButton.genelistName as string).toLocaleLowerCase().includes('metabon'))) continue
        const isNum = isNaN(Number(item[genelistProperty[k]])) || genelistProperty[k] === 'gene' ? item[genelistProperty[k]] : thousandth_formatter(Number(item[genelistProperty[k]].toFixed(2)));
        // 如果再给 makeElement 加上 props 参数，都不需要写工厂函数了
        const tdGene = makeCell(isNum, { 'value': isNum, 'title': isNum });
        tr.appendChild(tdGene);
        tdGene.addEventListener('click',()=>{
          this.change_single_gene(gene_protein,item[ genelistProperty[1] ],color);
        })
      }
      let orignColor = getInitColor(new Float32Array([0, 0, 0, 0]), new Uint64(item.id, this.genelist_res.totalCount)) as vec3;
      let color = serializeColor(vec3.fromValues(orignColor[0], orignColor[1], orignColor[2]));
      color = viewer.saveSelectedKeyVal && gene_protein in viewer.saveSelectedKeyVal ? viewer.saveSelectedKeyVal[gene_protein][1] : color;
      this.tbody.appendChild(tr);
      cb.addEventListener('change', async (e: Event) => {
        viewer.needRestoreHeatMapFilter = true;
        // 新增一条
        let _json = viewer.state.toJSON();
        let _newlayers = _json.layers;
        viewer.configStorage.setActivedTool('');
        if ((e.target as HTMLInputElement).checked) {
          tr.classList.add('splice-pic-tr_cb_checked');
          viewer.saveSelectedKeyVal[gene_protein] = [item[ genelistProperty[1] ],color, 1];
          this.selectedGeneStr = Object.keys(viewer.saveSelectedKeyVal).join(',')
          viewer.configStorage.clear();
          cb.classList.add(gene_protein);
          cb.checked = true;
          this.onlyHeatmap = viewer.layerManager.getLayerVisible(['ssDNA','DAPI','mask']);
          for (let i = 0; i < _newlayers.length; i++) {
            if (_newlayers[i].heatmap && _newlayers[i].genename === allToolsButton.genelistFile) {
              _newlayers[i].visible = true;
              _newlayers[i].shader = _newlayers[i].shader ? _newlayers[i].shader: '#uicontrol float sizeFactor slider(min=0.0, max=4.0, default=1.0, step=0.01); \n#uicontrol float oFactor slider(min=0.0, max=1.0, default=1.0, step=0.01); \nvoid main() { \n setColor(colormapNonlinear(prop_color(),vec3[9](vec3 (0.05,0.20,0.51),vec3 (0.00,0.37,0.64),vec3 (0.04,0.53,0.73),vec3 (0.00,0.76,0.60),vec3 (0.95,0.83,0.22),vec3 (0.96,0.69,0.20),vec3 (0.95,0.56,0.22),vec3 (0.91,0.38,0.14),vec3 (0.85,0.12,0.12)))); \n setPointMarkerFactor(sizeFactor); \n setPointMarkerOpacityFactor(oFactor - 0.01); \n}';
              _newlayers[i].hasData = true;
              _newlayers[i].source = `precomputed://${local_host_SN_flag}/annotation/many_gene/${this.selectedGeneStr}/${allToolsButton.genelistFile}/${viewer.binSize.value}`;
            }else if(_newlayers[i].heatmap && _newlayers[i].genename !== allToolsButton.genelistFile){
              _newlayers[i].visible = false;
              _newlayers[i].disabled = true;
            }
            if (_newlayers[i].name.includes('UMAP') || _newlayers[i].name.includes('cluster')) {
              _newlayers[i].disabled = true
            }
          }
          _newlayers.push(this.push_image_layer(gene_protein, color));
          _json.layers = _newlayers;
          _json.imageTools.showLegend = viewer.proteinMergeColor.value;
          _json.imageTools.showColorbar = !viewer.proteinMergeColor.value;
          _json.saveSelectedKeyVal = viewer.saveSelectedKeyVal;
          viewer.state.restoreState(_json);
          _json.proteinMergeColor = viewer.proteinMergeColor.value;
          viewer.resetoreJson(_json)
          if(!this.onlyHeatmap){
            let dimension = _json.dimensions;
            dimension['z'] = _json.dimensions.x;
            viewer.coordinateSpace.restoreState(dimension);
          }
          this.addNewSelectedItem(gene_protein,item[ genelistProperty[1] ],color, 1);
          // 修复之前隐藏的基因又会显示的问题
          setTimeout(() => {
            if(viewer.proteinMergeColor.value){
              for (let key in viewer.saveSelectedKeyVal) {
                if (viewer.saveSelectedKeyVal[key][2] === 0) {
                  let layer = viewer.layerManager.getLayerByName(key) as ManagedUserLayer;
                  layer.setVisible(false);
                }
              }
            };
          }, 500);
        }else{
          this.cb_checked_false(gene_protein);
        }
      });
    });
    this.loading.style.display = 'none';
    this.listEle.style.display = 'table';
    this.pagenation.style.display = 'flex';
    this.listEle.appendChild(this.tbody);
  }
  private genePagenation() {
    removeChildren(this.pagenation)
    const pageCurr = makeElement('input', ['el-pager-curr'], { 'value': this.pagenum }) as HTMLInputElement;
    const prevBtn = makeElement('button', ['btn-prev'], { "title": i18n.previous_page }, `${i18n.previous_page}`) as HTMLButtonElement;
    const pageDiv = makeElement('div', ['el-pager'], {}, '');
    const pageTotal = makeElement('p', ['el-pager'], {}, this.genelist_res.totalpage);
    const pageInner = makeElement('p', [], {}, '/');
    const nextBtn = makeElement('button', ['btn-next'], { "title": i18n.next_page }, `${i18n.next_page}`) as HTMLButtonElement;
    prevBtn.type = 'button';
    nextBtn.type = 'button';
    pageCurr.type = 'text';
    this.pagenation.appendChild(prevBtn);
    this.pagenation.appendChild(pageDiv);
    this.pagenation.appendChild(nextBtn);
    pageDiv.appendChild(pageCurr);
    pageDiv.appendChild(pageInner);
    pageDiv.appendChild(pageTotal);
    prevBtn.addEventListener('click', () => {
      if (this.pagenum > 1) {
        this.pagenum = Number(this.pagenum) - 1;
        pageCurr.setAttribute('value', this.pagenum);
        this.initGeneTable();
      } else {
        new message(i18n.genePanelFirstpage, 'info');
      }
    })
    nextBtn.addEventListener('click', () => {
      if (this.pagenum < this.genelist_res.totalpage) {
        this.pagenum = Number(this.pagenum) + 1;
        pageCurr.setAttribute('value', this.pagenum);
        this.initGeneTable();
      } else {
        new message(i18n.genePanelLastpage, 'info');
      }
    });
    pageCurr.addEventListener('change', (event: Event) => {
      event.stopPropagation();
      if (Number((event.target as HTMLInputElement).value) >= 1 && (event.target as HTMLInputElement).value <= this.genelist_res.totalpage && Number((event.target as HTMLInputElement).value)%1 === 0) {
        this.pagenum = Number((event.target as HTMLInputElement).value);
        this.initGeneTable();
      } else {
        new message(i18n.genePanelIllegalpage, 'error');
        pageCurr.value = this.pagenum;
      }
    });
  }
  change_single_gene(name: string, num: number, color: string){
    if(viewer.binSize.value === 'cellbin') return
    const cb_dom = document.getElementsByClassName(`${name}_cb`)[0] as HTMLInputElement;
    const cb_checked = cb_dom.checked;
    const tr_dom = document.getElementsByClassName(`splice-pic-tr_${name}`)[0];
    if(cb_checked){
      cb_dom.checked = false;
      this.cb_checked_false(name);
    }else{
      if(Object.keys(viewer.saveSelectedKeyVal).length > 1)return;
      let json = viewer.state.toJSON();
      let layers = json.layers;
      if(Object.keys(viewer.saveSelectedKeyVal).length === 0){
        layers.push(this.push_image_layer(name, color));
      }
      viewer.needRestoreHeatMapFilter = true;
      cb_dom.checked = true;
      cb_dom.classList.add(name);
      tr_dom.classList.add('splice-pic-tr_cb_checked');
      const exist_gene = Object.keys(viewer.saveSelectedKeyVal)[0];
      // this.deleteSelectedLayer(Object.keys(viewer.saveSelectedKeyVal)[0], false);
      const cb = document.getElementsByClassName(exist_gene + '_cb')[0] as HTMLInputElement;
      if(cb)cb.checked = false;
      const exist_ts_dom = document.getElementsByClassName(`splice-pic-tr_${exist_gene}`)[0]
      const selected_gene = document.getElementsByClassName(`selected-tr-${exist_gene}`)[0];
      if(exist_ts_dom)exist_ts_dom.classList.remove('splice-pic-tr_cb_checked')
      if(selected_gene)this.selectedBody.removeChild(selected_gene);
      delete viewer.saveSelectedKeyVal[exist_gene];
      viewer.configStorage?.configDialog?.close();
      viewer.clearActiveTool();
      viewer.saveSelectedKeyVal[name] = [num,color, 1];
      this.selectedGeneStr = Object.keys(viewer.saveSelectedKeyVal).join(',')
      viewer.configStorage.clear();
      layers.forEach((item:any)=>{
        if(item.genetype === 'proteinimage'){
          item.genename = name;
          item.source = `precomputed://${local_host_SN_flag}/image/gene/${name}/${allToolsButton.genelistFile}/${viewer.binSize.value as string}`;
          item.hasData = viewer.proteinMergeColor.value;
          item.visible = viewer.proteinMergeColor.value;
          item.name = name;
          item.genecolor = color;
          item.shader = this.get_image_layer_shader(color);
        }else if(item.genename === allToolsButton.genelistFile){
          item.source = `precomputed://${local_host_SN_flag}/annotation/many_gene/${name}/${allToolsButton.genelistFile}/${viewer.binSize.value}`;
          item.visible = true;
          item.hasData = true;
        }else if(item.heatmap && item.genename !== allToolsButton.genelistFile){
          item.visible = false;
          item.disabled = true;
        }
        if (item.name.includes('UMAP') || item.name.includes('cluster')) {
          item.disabled = true
        }
      });
      json.layers = layers;
      viewer.state.restoreState(json);
      json.saveSelectedKeyVal = viewer.saveSelectedKeyVal;
      viewer.resetoreJson(json)
      this.addNewSelectedItem(name, num, color, 1);
    }
  }
  addNewSelectedItem(name: string, num: number, color: string, opacity: number){
    this.selectedGeneDom.style.display = 'block';
    document.getElementsByClassName('selected-gene-all-layer-visible')[0].innerHTML = this.layer_showSvg;
    document.getElementsByClassName('selected-gene-all-layer-visible')[0].setAttribute('data-checked', 'true');
    const table = document.getElementsByClassName('genetable-selected-table')[0];
    viewer.proteinMergeColor.value ? table.classList.remove('mutil-color-property-show') : table.classList.add('mutil-color-property-show');
    if (document.getElementsByClassName('gene-save-filter')[0]) {
      (document.getElementsByClassName('gene-save-filter')[0] as HTMLElement).style.display = viewer.proteinMergeColor.value ? 'flex' : 'none';
    }
    const tr = document.createElement('tr');
    tr.classList.add('splice-pic-tr','splice-pic-tr-selected',`selected-tr-${name}`,`${num}-${color}`);
    const cb = makeElement("input") as HTMLInputElement;
    cb.type = "checkbox";
    cb.checked = true;
    cb.classList.add('ng-common-checkbox');
    const td = makeElement("td", [], defaultSpans) as HTMLTableCellElement;
    const cell = makeElement("div", ["cell"]);
    cell.appendChild(cb);
    td.appendChild(cell);
    tr.appendChild(td);
    const _num = thousandth_formatter(Number(num.toFixed(2))).toString();
    const tdname = makeCell(name, { 'value': name, 'title': name });
    const tdnum = makeCell(_num, { 'value': _num, 'title': _num });
    tr.appendChild(tdname);
    tr.appendChild(tdnum);
    const colortTd = makeElement("td", [], defaultSpans) as HTMLTableCellElement;
    const colorCell = makeElement("div", ["cell", 'selected-gene-color']);
    const colorItmen = makeElement("div", ["color"]);
    const { layer_showSvg, layer_hideSvg } = this
    const layer_visible = makeElement('div',['selected-gene-single-layer-visible'],{'data-checked': 'true'},`${opacity === 0 ? layer_hideSvg : layer_showSvg}`);
    colorItmen.classList.add('color-widget-'+name);
    colorItmen.style.background = color;
    colorCell.append(colorItmen);
    colorCell.appendChild(layer_visible);
    colortTd.appendChild(colorCell)
    colorItmen.addEventListener('click',()=>{
      if (!cb.checked) return
      if(viewer.proteinMergeColor.value){
        viewer.selectedLayer.layer = viewer.layerManager.getLayerByName(name);
        viewer.selectedLayer.visible = true;
        viewer.configStorage.clear();
        viewer.configStorage.registParentSingle(name, colorCell) // 每次点击选中都注册，避免restoState的时候dom更新，配置窗位置异常
        viewer.configStorage.setActivedTool(name)
      }
    });
    this.registerEventListener(layer_visible, 'click', ()=>{ this.hide_or_show_single_layers(layer_visible, name) });
    cb.addEventListener('change',()=>{
      this.selectedBody.removeChild(tr);
      this.deleteSelectedLayer(name);
     if(document.getElementsByClassName(`${name}`)[0]){
      (document.getElementsByClassName(`${name}`)[0] as HTMLInputElement).checked = false;
      (document.getElementsByClassName(`${name}`)[0] as HTMLInputElement).parentElement?.parentElement?.parentElement?.classList.remove('splice-pic-tr_cb_checked')
     }
    })
    tr.appendChild(colortTd);
    this.selectedBody.appendChild(tr);
    this.selectedCount++;
    const select = Object.keys(viewer.saveSelectedKeyVal).length;
    if(document.getElementsByClassName('gene-selected-bottom')[0])(document.getElementsByClassName('gene-selected-bottom')[0] as HTMLElement).style.display = 'flex';
    if(document.getElementsByClassName('selected-gene-num')[0])document.getElementsByClassName('selected-gene-num')[0].innerHTML = `${select} ${i18n.genePanelSelectedGene}`;
  }
  deleteSelectedLayer(gene_protein: string){
    this.selectedCount--;
    delete viewer.saveSelectedKeyVal[gene_protein];
    this.selectedGeneStr = Object.keys(viewer.saveSelectedKeyVal).join(',')
    let _json = viewer.state.toJSON();
    let _newlayers = _json.layers;
    viewer.configStorage?.configDialog?.close();
    viewer.clearActiveTool();
    // 删除一条
    // removeChildren(document.getElementsByClassName('protein-legend-li-' + gene_protein)[1] as HTMLElement);
    const cb = document.getElementsByClassName(gene_protein)[0];
    if(cb)cb.removeAttribute('checked');
    _newlayers.forEach((item:any,index:number)=>{ 
      item.genename ===  gene_protein ? _newlayers.splice(index, 1): '';
      if (item.heatmap && item.genefile === allToolsButton.genelistFile) {
        item.visible = true;
        item.shader = item.shader ? item.shader: '#uicontrol float sizeFactor slider(min=0.0, max=4.0, default=1.0, step=0.01); \n#uicontrol float oFactor slider(min=0.0, max=1.0, default=1.0, step=0.01); \nvoid main() { \n setColor(colormapNonlinear(prop_color(),vec3[9](vec3 (0.05,0.20,0.51),vec3 (0.00,0.37,0.64),vec3 (0.04,0.53,0.73),vec3 (0.00,0.76,0.60),vec3 (0.95,0.83,0.22),vec3 (0.96,0.69,0.20),vec3 (0.95,0.56,0.22),vec3 (0.91,0.38,0.14),vec3 (0.85,0.12,0.12)))); \n setPointMarkerFactor(sizeFactor); \n setPointMarkerOpacityFactor(oFactor - 0.01); \n}';
        item.hasData = true;
        item.source = `precomputed://${local_host_SN_flag}/annotation/many_gene/${this.selectedGeneStr}/${allToolsButton.genelistFile}/${viewer.binSize.value}`;
      }
    });
    if (JSON.stringify(viewer.saveSelectedKeyVal) === '{}') {
      this.selectedGeneStr = '';
      (document.getElementsByClassName('gene-selected-bottom')[0] as HTMLElement).style.display = 'none';
      this.initReset();
      return
    }
    _json.layers = _newlayers;
    viewer.state.restoreState(_json);
    _json.saveSelectedKeyVal = viewer.saveSelectedKeyVal;
    viewer.resetoreJson(_json)
    if(!this.onlyHeatmap){
      let dimension = _json.dimensions;
      dimension['z'] = _json.dimensions.x;
      viewer.coordinateSpace.restoreState(dimension);
    }
    if (document.getElementsByClassName('protein-legend-li-' + gene_protein)[0]) {
      removeChildren(document.getElementsByClassName('protein-legend-li-' + gene_protein)[0] as HTMLElement);
    }
    const select = Object.keys(viewer.saveSelectedKeyVal).length;
    document.getElementsByClassName('selected-gene-num')[0].innerHTML = `${select} ${i18n.genePanelSelectedGene}`;
    (document.getElementsByClassName('gene-selected-bottom')[0] as HTMLElement).style.display = 'flex';
    viewer.selectedLayer.layer = undefined;
    viewer.configDialog?.close();
    viewer.clearActiveTool();
    // 修复之前隐藏的基因又会显示的问题
    setTimeout(() => {
      if(viewer.proteinMergeColor.value){
        for (let key in viewer.saveSelectedKeyVal) {
          if (viewer.saveSelectedKeyVal[key][2] === 0) {
            let layer = viewer.layerManager.getLayerByName(key) as ManagedUserLayer;
            layer.setVisible(false);
          }
        }
      };
    }, 500);
    setTimeout(() => {
      viewer.tissueGefOutline?.updateView();
    }, 1000);
  }
  initReset(){
    let nodeList = document.body.querySelectorAll(".can_zoom_move_container") as NodeList;
    nodeList.forEach((item:Node)=>document.body.removeChild(item));
    viewer.clearActiveTool();    
    viewer.saveSelectedKeyVal = {};
    this.selectedGeneDom.style.display = 'none';
    this.selectedGeneDom.removeChild(this.selectedTableDom);
    this.selectedGeneStr = '';
    let json = viewer.state.toJSON();
    let newlayers = json.layers;
    viewer.proteinMergeColor.value = false;
    for (let i = 0; i < newlayers.length; i++) {
      if (newlayers[i].genetype === 'proteinimage' && !newlayers[i].genename.includes('ssDNA') && !newlayers[i].genename.includes('_IF')) {
        (document.getElementsByClassName('colorBarScale')[0] as HTMLElement).style.display = 'none';
        if(document.getElementsByClassName(newlayers[i].genename)[0]){
          (document.getElementsByClassName(newlayers[i].genename)[0] as HTMLInputElement).checked = false;
        }
        newlayers.splice(i, 1);
        i--;
      }
      if (newlayers[i].heatmap) {
        newlayers[i].source = `precomputed://${local_host_SN_flag}/annotation/dnb/${newlayers[i].genename}/${viewer.binSize.value}`;
        newlayers[i].visible = newlayers[i].genename === allToolsButton.genelistFile;
        newlayers[i].hasData = true;
        newlayers[i].disabled = false;
        if(newlayers[i].visible)allToolsButton.genelistFile = newlayers[i].genename
      }
      if(newlayers[i]?.genetype === 'image' && newlayers[i].hasData){
        json.position.splice(2, 1);
        delete json.dimensions.z;
      }
      if (document.getElementsByClassName('success-row')[0]) {
        document.getElementsByClassName('success-row')[0].className = '';
      }
      if( (newlayers[i].name.includes('UMAP') || newlayers[i].name.includes('cluster')) && (viewer.binSize.value === 'bin200' || (allToolsButton.genelistName as string)?.toLocaleLowerCase().includes('metabon')) ){
        newlayers[i].disabled = !newlayers[i].hasData;
      }
    }
    json.layers = newlayers;
    json.imageTools.showColorbar = true;
    json.proteinMergeColor = false;
    json.binSize = viewer.binSize.value;
    viewer.state.restoreState(json);
    viewer.resetoreJson(json);
    if(!this.onlyHeatmap){
      json.position.splice(2, 1);
      let dimension = json.dimensions;
      dimension['z'] = json.dimensions.x;
      viewer.coordinateSpace.restoreState(dimension);
    }
    this.initGeneTable();
    viewer.configStorage?.configDialog?.close();
    viewer.layout.container.initColorScale();
    viewer.configStorage.clear();
    viewer.configStorage.setActivedTool('');
    this.selectedTableDom.classList.remove('fold');
    this.selectedTableDom.classList.add('expand');
    this.geneElement.classList.remove('fold');
    this.geneElement.classList.add('expand');
    this.pagenation.classList.add('expand');
    this.pagenation.classList.remove('fold');
    if(viewer.layerManager.getLayerVisible('protein')){
      // viewer.layout.container.initColorScale();
    }
    setTimeout(() => {
      viewer.tissueGefOutline?.updateView();
      if(viewer.binSize.value === 'bin200')changeBinSize('bin200');
    }, 100);
  }
  async getGenelist(){
    this.listEle.innerHTML = '';
    this.geneElement.appendChild(this.loading)
    this.loading.style.display = 'block';
    this.pagenation.style.display = 'none';
    await this.getGenelistReq();
  }
  async getGenelistReq(){
    const _filterParam = this.filterparam.replace(/\s*/g,"").replace(/\#/g,"%23").replace(/\%/g,"%25").replace(/\&/g,"%26").replace(/\+/g,"%2B").replace(/\./g,"%2E");
    let reqUrl: any = `${local_host_SN_flag}/${viewer.binSize.value === 'cellbin' ? 'cellbin' : 'annotation'}/genelist?pagesize=100&pagenum=${this.pagenum}`;
    reqUrl = this.sortname ? reqUrl + '&sort={"name":"' + this.sortname + '","isAsc":' + this.isasc + '}' : reqUrl;
    reqUrl = this.filterparam ? reqUrl + '&filterparam='+_filterParam : reqUrl;
    reqUrl = reqUrl + `&file=${this.getgeneFile()}`
    let req = async (): Promise<any> => {
      return await cancellableFetchSpecialOk(undefined, `${reqUrl}`, {}, responseJson);
    };
    this.genelist_res = await req();
  }
  addkeyDown(){
    this.registerEventListener(window, 'keyup', debounce(async(event: KeyboardEvent) => {
      if(event.code !== 'ArrowUp' && event.code !== 'ArrowDown') return
      event.preventDefault();
      const str = Object.keys(viewer.saveSelectedKeyVal).join(',').split(',');
      const pageCurr = document.getElementsByClassName('el-pager-curr')[0] as HTMLInputElement;
      if(Object.keys(viewer.saveSelectedKeyVal).length !== 1)return;
      let cur_index = 0;
      let genelist = this.genelist_res.data;
      let next_gene = genelist.filter((item:any,index: number) => {
        if(item.gene === str[0])cur_index = index;
        return item.gene === str[0];
      })[0];
      if(!next_gene)return;
      let is_break = false;     //  中断操作
      let color: string = '';
      if (event.code === 'ArrowUp') {
        if (Number(pageCurr.value) === 1 && cur_index === 0) {
          new message(i18n.genePanelAttop, 'info');
          is_break = true;
        } else if (cur_index === 0 && Number(pageCurr.value) !== 1) {
          this.pagenum = Number(this.pagenum) - 1;
          pageCurr.setAttribute('value', this.pagenum);
          await this.getGenelistReq();
          genelist = this.genelist_res.data;
          next_gene = genelist[genelist.length - 1];
          viewer.saveSelectedKeyVal = {};
          viewer.saveSelectedKeyVal[next_gene.gene] = [next_gene.MIDcount,color];
        } else {
          let orignColor = getInitColor(new Float32Array([0, 0, 0, 0]), new Uint64(next_gene.id - 1, this.genelist_res.totalCount)) as vec3;
          color = serializeColor(vec3.fromValues(orignColor[0], orignColor[1], orignColor[2]));
          viewer.saveSelectedKeyVal = {};
          viewer.saveSelectedKeyVal[genelist[cur_index - 1].gene] = [genelist[cur_index - 1].MIDcount,color];
        }
      } else if (event.code === 'ArrowDown') {
        if( (cur_index === genelist.length - 1) && !(this.genelist_res.totalpage === Number( pageCurr.value ))){
          this.pagenum = Number(this.pagenum) + 1;
          pageCurr.setAttribute('value', this.pagenum);
          await this.getGenelistReq();
          genelist = this.genelist_res.data;
          next_gene = genelist[0];
          let orignColor = getInitColor(new Float32Array([0, 0, 0, 0]), new Uint64(next_gene.id + 1, this.genelist_res.totalCount)) as vec3;
          color = serializeColor(vec3.fromValues(orignColor[0], orignColor[1], orignColor[2]));
          viewer.saveSelectedKeyVal = {};
          viewer.saveSelectedKeyVal[genelist[0].gene] = [genelist[0].MIDcount,color];
        }else if(this.genelist_res.totalpage === Number( pageCurr.value ) && cur_index === genelist.length - 1){
          new message(i18n.genePanelAtbottom, 'info');
          is_break = true
        }else{
          let orignColor = getInitColor(new Float32Array([0, 0, 0, 0]), new Uint64(next_gene.id + 1, this.genelist_res.totalCount)) as vec3;
          color = serializeColor(vec3.fromValues(orignColor[0], orignColor[1], orignColor[2]));
          viewer.saveSelectedKeyVal = {};
          viewer.saveSelectedKeyVal[genelist[cur_index + 1].gene] = [genelist[cur_index + 1].MIDcount,color];
        }
      }
      if(is_break)return;
      super.disposed();
      await this.initGeneTable(false);
      const genename = Object.keys(viewer.saveSelectedKeyVal)[0];
      let new_json = viewer.state.toJSON();
      const dimension = JSON.parse(JSON.stringify(new_json)).dimensions;
      const _layers = new_json.layers;
      const protein_index = _layers.length - 1;
      for(let i = 0 ; i < _layers.length; i++){
        if(_layers[i].heatmap && _layers[i].genefile === allToolsButton.genelistFile){
          _layers[i].source = `precomputed://${local_host_SN_flag}/annotation/many_gene/${genename}/${allToolsButton.genelistFile}/${viewer.binSize.value}`;
          break;
        }
      }
      _layers[protein_index].genename = genename
      _layers[protein_index].name = genename;
      _layers[protein_index].genecolor = color;
      _layers[protein_index].source = `precomputed://${local_host_SN_flag}/image/gene/${genename}/${allToolsButton.genelistFile}/${viewer.binSize.value}`;
      _layers[protein_index].shader = "#uicontrol invlerp normalized\n#uicontrol float brightness slider(min=-1, max=1)\n#uicontrol float contrast slider(min=-3, max=10, step=0.01, default=1.0)\n#uicontrol vec3 color color(default=\"" + color + "\")\nvoid main() {\n  emitRGB(color*(normalized()+brightness)*exp(contrast));\n}",
      _layers[protein_index].shaderControls['color'] = color;
      new_json.layers = _layers;
      viewer.state.restoreState(new_json);
      viewer.coordinateSpace.restoreState(dimension);
      viewer.configDialog?.close();
      viewer.configStorage.clear();
      viewer.clearActiveTool();
    },1000));
  }
  async getAllMaxValue(){
    // const file = this.getgeneFile();
    // await cancellableFetchSpecialOk(undefined, `${local_host_SN_flag}/image/${file}/maxValue`, {}, responseJson).then((res:any)=>{
    //   if(res.code === 0){
    //     viewer.binsizeMaxvalue = res.data;
    //   }
    // })
    let p:any = [];
    for(let i = 0; i < (allToolsButton.bin_list as string[]).length; i++){
      if(allToolsButton.bin_list[i] !== 'cellbin'){
        const file = this.getgeneFile();
        let req = new Promise(async (resolve, reject) => {
          const response = await cancellableFetchSpecialOk(undefined, `${local_host_SN_flag}/image/gene/abc/${file}/${allToolsButton.bin_list[i]}/maxValue`, {}, responseJson);
          try {
            resolve(response);
          } catch (error) {
            reject(error);
          }
        }).then((res:any)=>{
          this.imageMaxValue[allToolsButton.bin_list[i]] = res?.data?.maxValue ?? 0;
        })
        p.push(req);
      }
    }
    Promise.all( p ) .then ( () => {
      // console.log(this.imageMaxValue)
    })
    viewer.binsizeMaxvalue = this.imageMaxValue;
  }
  getgeneFile(){
    // if(viewer.binSize.value?.includes('cellbin')){
    //   return (viewer.layerManager.getLayerByName('cellbin_heatmap', 'genename') as ManagedUserLayer).genefile
    // }else{
      return allToolsButton.genelistFile
    // }
  }
  hide_or_show_all_layers(layer_visible: HTMLElement){
    if(viewer.proteinMergeColor.value){
      layer_visible.dataset.checked = layer_visible.dataset.checked === 'true' ? 'false' : 'true';
      layer_visible.innerHTML = layer_visible.dataset.checked === 'true' ? this.layer_showSvg : this.layer_hideSvg;
      const list = document.querySelectorAll('.selected-gene-single-layer-visible');
      list.forEach((item: HTMLElement)=> {
        item.innerHTML = layer_visible.dataset.checked === 'true' ? this.layer_showSvg : this.layer_hideSvg;
        item.dataset.checked = layer_visible.dataset.checked === 'true' ? 'true' : 'false';
      })
      const layers = viewer.layerManager.managedLayers;
      for(let i = 0; i < layers.length; i++){
        if(layers[i].genetype === 'proteinimage'){
          layers[i].setVisible(layer_visible.getAttribute('data-checked') === 'true');
          viewer.saveSelectedKeyVal[layers[i].genename][2] = layers[i].visible ? 1 : 0;
        }
      }
    }
  }
  hide_or_show_single_layers(layer_visible: HTMLElement, name: string){
    if(viewer.proteinMergeColor.value){
      const layer = viewer.layerManager.getLayerByName(name) as ManagedUserLayer;
      layer_visible.dataset.checked = layer_visible.dataset.checked === 'true' ? 'false' : 'true';
      viewer.saveSelectedKeyVal[name][2] = layer_visible.getAttribute('data-checked') === 'true' ? 1 : 0;
      layer.setVisible( layer_visible.getAttribute('data-checked') === 'true' )
      layer_visible.innerHTML = viewer.saveSelectedKeyVal[name][2] === 0 ? this.layer_hideSvg : this.layer_showSvg;
    };
    const needShow = Object.values(viewer.saveSelectedKeyVal).every((item)=> item[2] === 1);
    const needHide = Object.values(viewer.saveSelectedKeyVal).every((item)=> item[2] === 0)
    const all_layer_v = document.getElementsByClassName('selected-gene-all-layer-visible')[0];
    if( needShow || needHide ){
      all_layer_v.innerHTML = needShow ? this.layer_showSvg : this.layer_hideSvg;
      all_layer_v.setAttribute('data-checked', needShow ? this.layer_showSvg : this.layer_hideSvg);
    }else{
      all_layer_v.innerHTML = this.layer_showSvg;
      all_layer_v.setAttribute('data-checked', 'true');
    }
  }
  async save_filter_info_and_gef(){
    if(!(await check_balance()))return
    // new geneTableSave(viewer)
    // 入仓
    document.getElementsByClassName("mid_filter_run_submit")[0].classList.add('submit_btn_loading');
    const curr_layer = viewer.layerManager.managedLayers.filter((item)=> (item.genename === allToolsButton.genelistFile))[0];
    let sample_id = curr_layer.genesn || local_href_param.sn;
    let filters:any = [];
    viewer.layerManager.managedLayers.forEach( (item:ManagedUserLayer)=>{
      if(item.layer?.genetype === 'proteinimage'){
        let range = (item.layer as ImageUserLayer).shaderControlState.toJSON().midFilter.range;
        filters.push({
          Gene: item.genename,
          MinFilterMID: range[0],
          MaxFilterMID: range[1]
        })
      }
    });
    const bin = viewer.binSize.value || "1";
    const binSizes = bin.includes('bin') && bin!== 'cellbin' ? Number(bin.replace('bin','')): 1;
    const filename = `${sample_id}.${getData()}.MIDfilter.json`;
    const data_warehouse_param = {
      project_id: local_href_param.projectId,
      filename: filename,
      path: '/Files/ManualData/StereoMap/MIDfilter/',
      sample_id: sample_id,
      data: {
        "bin_size": binSizes,
        "file": allToolsButton.genelistFile,
        "filters": filters,
      }
    }
    let json = {
      method: 'post',
      body: JSON.stringify(data_warehouse_param),
      headers: { "Content-Type": "application/json" }
    }
    let req = async (): Promise<any> => {
      return await cancellableFetchSpecialOk(undefined, `${local_host_SN_flag}/data_warehouse`, json, responseJson);
    };
    let res = await req();
    document.getElementsByClassName("mid_filter_run_submit")[0]?.classList.remove('submit_btn_loading');
    if (res.code === 0) {
      new message(`${i18n.registrationPanelFilePath}${i18n.registrationPanelDataManagement}/Files/ManualData/StereoMap/MIDfilter/${filename}`, 'success', true);
      let lasso_group_bin: any = {
        bin_list: [],
        bgef_path: '',
        cgef_path: []
      };
      if (local_href_param.flag === 'tool') {
        lasso_group_bin = await get_binlist_group(curr_layer);
      }
      console.log(curr_layer?.filename);
      const workflow_params = await getWorkflowParam('MIDfilter', curr_layer?.filename);
      console.log(workflow_params);
      workflow_params.bgef = workflow_params.bgef || lasso_group_bin.bgef_path;
      const bgef = curr_layer?.menupath || workflow_params.bgef;
      const sampleId = local_href_param.flag !== 'tool' ? workflow_params.sampleId || '' : curr_layer.genesn;
      let param:any = {};
      param['MIDfilter'] = {
        src: 'SteroMapV3',
        type: 'params',
        originTaskId: local_href_param.flag === 'tool' ? curr_layer.taskid : local_href_param.DataID,
        sampleId: sampleId,
        value:{
          SN: sampleId,
          Gef: bgef ? [bgef] : [],                      //  gef文件路径
          Json: '/Files/ManualData/StereoMap/MIDfilter/' + filename,
        }
      };
      viewer.workflowManualtoolsDialog = new registerLassoOpenDialog('MIDfilter', param);
    } else {
      new message(`${i18n.asyncfail}${res.msg}`, 'error');
    }
  }
  push_image_layer(name: string, color: string){
    const layer = {
      "genename": name,
      "genecolor": color,
      "type": 'image',
      "source": `precomputed://${local_host_SN_flag}/image/gene/${name}/${allToolsButton.genelistFile}/${viewer.binSize.value}`,
      "tab": "rendering",
      "opacity": 1,
      "shader": this.get_image_layer_shader(color),
      "name": name,
      "genetype": "proteinimage",
      "blend": "additive",
      "visible": viewer.proteinMergeColor.value,
      "hasData": viewer.proteinMergeColor.value,
    }
    return layer
  }
  get_image_layer_shader(color: string){
    return `
    #uicontrol invlerp midFilter
    #uicontrol invlerp normalized
    #uicontrol float brightness slider(min=-1, max=1)
    #uicontrol float contrast slider(min=-3, max=10, step=0.01, default=1.0)
    #uicontrol vec3 color color(default=\" ${color} \")
    void main() {
      float value = midFilter();
      if( value > 0. && value < 1.0){
        emitRGB(color * (normalized() + brightness) * exp(contrast));
      }else{
        emitRGB(vec3(0.0,0.0,0.0));
      }
    }
  `
  }
  cb_checked_false(name: string){
    const tr = document.getElementsByClassName(`splice-pic-tr_${name}`)[0];
    tr.classList.remove('splice-pic-tr_cb_checked')
    this.selectedBody.removeChild(document.getElementsByClassName(`selected-tr-${name}`)[0]);
    this.deleteSelectedLayer(name);
  }
  dispose(){
    removeFromParent(this.element);
    super.dispose();
  }
}
// class geneTableSave extends Overlay {
//   gefPath: string | undefined
//   gefTaskId: string | undefined
//   constructor(public viewer: Viewer){
//     super();
//     this.initDom();
//     this.content.appendChild(this.buttonClose);
//     this.registerEventListener(this.buttonClose, 'click', () => {this.dispose();});
//     this.registerEventListener(document.getElementsByClassName('record_gene_filter_btn')[0], 'click', this.record_gene_filter.bind(this));
//     this.registerEventListener(document.getElementsByClassName('save_and_output_btn')[0], 'click', this.save_and_output_btn.bind(this));
//     this.registerEventListener(document.getElementById('save_gene_filter_cancel')!, 'click', () => {this.dispose();});
//   }
//   initDom(){
//     this.content.classList.add('save_gene_filter_dialog', 'state_operate_dialog');
//     this.content.innerHTML += `
//     <div class="save_head">${i18n.dialogSave}</div>
//     <div class="dialog_container">
//       <div class="dialog_tips">${i18n.genePanelStateOutput}</div>
//       <div class="dialog_tips dialog_tips_gray">${i18n.genePanelStateDatapath}</div>
//     </div>
//     <div class="footer" style="display: flex;justify-content: space-around;align-items: center;">
//       <button class="record_gene_filter_btn">${i18n.save}</button>
//       <button class="save_and_output_btn">${i18n.genePanelStateSaveOutput}</button>
//       <button id="save_gene_filter_cancel">${i18n.cancel}</button>
//     </div>
//     `
//   }
//   async record_gene_filter(){
//     const param = this.getParams()
//     await this.output_filter_json(param);
//     this.dispose();
//   }
//   async outputFilterGefFile(param: any){
//     this.disableEscKeyEvent = true;
//     let json = {
//       method: 'POST',
//       body: JSON.stringify(param),
//       headers: {
//         'Content-Type': 'application/json'
//       },
//   }
//     this.content.classList.add('run_gef_overlay');
//     this.content.innerHTML =
//       `<div class="progress_wrap">
//         <div class="progress_bar"></div>
//       </div>
//       <div class="loading_tips" id="outPutGefFileTips">${i18n.running}...</div>`;

//     await cancellableFetchSpecialOk(undefined, `${local_host_SN_flag}/annotation/generate_gef`, json, responseJson).then((res)=>{
//       if(res.code === 0){
//         // new message(i18n.registrationPanelFilePath + res.data.path, 'success', true);
//         this.gefPath = res.data.path;
//         this.gefTaskId = res.data.task_id;
//         this.pollingGefGenerateStatus();
//       }else{
//         new message(res.msg, 'error');
//         this.dispose();
//       }
//     })
//   }
//   async output_filter_json(param: any){
//     let json = {
//       method: 'POST',
//       body: JSON.stringify(param),
//       headers: {
//         'Content-Type': 'application/json'
//       },
//     }
//     await cancellableFetchSpecialOk(undefined, `${local_host_SN_flag}/annotation/record_gene_filter_info`, json, responseJson).then((res)=>{
//       if(res.code === 0){
//         new message(i18n.registrationPanelFilePath + res.data.path, 'success', true)
//       }else{
//         new message(res.msg, 'error')
//       }
//     })
//     }
//   pollingGefGenerateStatus() {
//     setTimeout(()=>{
//       let json = {
//         method: 'GET',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//       }
//       cancellableFetchSpecialOk(undefined, `${local_host_SN_flag}/annotation/get_task_process/${this.gefTaskId}`, json, responseJson).then((res)=>{
//         if(res.code === 0){
//           const tipsDom = document.getElementById('outPutGefFileTips') as HTMLElement;
//           switch (res.data.process) {
//             case 0:
//               tipsDom.innerHTML = 'prepare datas';
//               this.pollingGefGenerateStatus();
//               break
//             case 1:
//               tipsDom.innerHTML = 'filter datas';
//               this.pollingGefGenerateStatus();
//               break
//             case 2:
//               tipsDom!.innerHTML = 'process datas & write to bgef';
//               this.pollingGefGenerateStatus();
//               break
//             case 3:
//               new message(i18n.registrationPanelFilePath + this.gefPath, 'success', true);
//               this.dispose();
//               break
//             case -1:
//               new message('task error:' + res.data.status, 'error', true);
//               this.dispose();
//               break
//             default:
//               new message('unknown process code:' + res.data.process, 'error', true);
//               this.dispose();
//               break
//   }
//         }
//       })
//     }, 10000)
//   }

//   async save_and_output_btn(){
//     const param = this.getParams();
//     this.output_filter_json(param);
//     await this.outputFilterGefFile(param);
//   }
//   getParams(){
//     let filters:any = [];
//     this.viewer.layerManager.managedLayers.forEach( (item:ManagedUserLayer)=>{
//       if(item.layer?.genetype === 'proteinimage'){
//         let range = (item.layer as ImageUserLayer).shaderControlState.toJSON().midFilter.range
//         filters.push({
//           Gene: item.genename,
//           MinFilterMID: range[0],
//           MaxFilterMID: range[1]
//         })
//       }
//     });

//     const bin = viewer.binSize.value || "1";
//     const binSizes = bin.includes('bin') && bin!== 'cellbin' ? Number(bin.replace('bin','')): 1;
//     return {
//       filters: filters,
//       bin_size: binSizes,
//       file: allToolsButton.genelistFile
//     }
//   }
// }
let lasso_bin:any = {
  bin_list: [],
  bgef_path: '',
  cgef_path: []
};
async function get_binlist_group(layer: any){
  console.log(layer.taskid);
  const taskId = layer.taskid;
  if(taskId){
    let req = async (): Promise<any> => {
      return await cancellableFetchSpecialOk(undefined, `${local_host_SN_flag}/get_group_bin/${layer.taskid}/${layer.filename}`, {}, responseJson);
    };
    const res = await req();
    lasso_bin = res.data;
  }
  return lasso_bin;
}